import { render } from "./AcceptAgencyInvite.vue?vue&type=template&id=85f987a2"
import script from "./AcceptAgencyInvite.vue?vue&type=script&lang=js"
export * from "./AcceptAgencyInvite.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__